var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 19.168L13.815 10.981L22 2.807L19.168 0L10.986 8.179L2.81 0L0 2.81L8.186 11.006L0 19.19L2.81 22L11.013 13.808L19.193 22L22 19.168Z",
    fill: "#DAD2C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsClose);
export default __webpack_public_path__ + "static/media/settings-close.3dedaaa0c848a5cb8495fb9af2247971.svg";
export { ForwardRef as ReactComponent };